// ============================================================================
// dataSP — "hoje" no fuso de São Paulo (06/10/2026)
// ============================================================================
// `new Date().toISOString().slice(0, 10)` dá o dia em UTC: depois das 21h em
// São Paulo já é "amanhã" — conta paga às 22h do dia 31 caía no mês seguinte.
// Use hojeSP() sempre que a data for gravada como DIA (date, data_pagamento,
// data de pagamento da folha...). Mesmo fuso do servidor (api/_lib/ponto.js).
// ============================================================================

const FUSO = 'America/Sao_Paulo';

// Dia (YYYY-MM-DD) de um instante no fuso de SP. Monta pelas partes em vez de
// confiar no formato do locale (en-CA muda de formato entre motores de ICU).
export function diaSP(instante = new Date()) {
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: FUSO, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(instante);
  const p = (t) => partes.find(x => x.type === t)?.value || '';
  return `${p('year')}-${p('month')}-${p('day')}`;
}

// Hoje (YYYY-MM-DD) em São Paulo.
export function hojeSP() {
  return diaSP(new Date());
}
